import Header from './components/Header';
import Hero from './components/Hero';
import BasicSpecs from './components/BasicSpecs';
import Merits from './components/Merits';
import DepositGuide from './components/DepositGuide';
import Demerits from './components/Demerits';
import Reviews from './components/Reviews';
import SuitableFor from './components/SuitableFor';
import HowToApply from './components/HowToApply';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';
import SEO from '../../components/base/SEO';

export default function NexusCard() {
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="デポジット型クレジットカード完全ガイド｜審査が不安な方向け2026年最新版"
        description="デポジット型クレジットカードの特徴、メリット・デメリット、申込方法を徹底解説。審査が不安な方、フリーランス・個人事業主の方におすすめ。年会費1,375円、デポジット5万円〜200万円で利用可能。"
        keywords="デポジット型クレジットカード,審査不安,フリーランス,個人事業主,保証金型カード,Mastercard"
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: 'カード詳細', path: '/ranking' },
        { label: 'デポジット型クレジットカード' }
      ]} />
      <Hero />
      <CTASection />
      <BasicSpecs />
      <Merits />
      <DepositGuide />
      <Demerits />
      <CTASection />
      <Reviews />
      <SuitableFor />
      <HowToApply />
      <CTASection />
      <Footer />
    </div>
  );
}
